import { useState, useCallback, useRef, useEffect } from 'react';
import RepublicMap from '@pages/sales-network/RepublicMap';
import RegionsClinics from '@pages/sales-network/regions-clinics/RegionsClinics';



const SalesNetwork = (): JSX.Element => {

	const [ selectedRegion, setSelectedRegion ] = useState<string>('');

	const footerRef = useRef<HTMLDivElement | null>(null);


	useEffect(() => {
		if (selectedRegion !== '') {
			setTimeout(() => footerRef?.current?.scrollIntoView({ behavior: 'smooth', block: 'nearest' }), 150);
		}
	}, [ selectedRegion, footerRef ]);

	
	const handleRegionClick = useCallback((regionId: string) => {
		regionId === selectedRegion ? setSelectedRegion('') : setSelectedRegion(regionId);
	},[ selectedRegion ]);

	
	return (
		<div className="app-page sales-network-page">
			
			<h1>Prodejní síť</h1>

			<div className='info-item'>
				<p>Najděte pohodlně veterinární ordinaci ve&nbsp;Vašem kraji.</p>
			</div>

			<RepublicMap
				selectedRegion={selectedRegion}
				onRegionClick={handleRegionClick} />

			<RegionsClinics
				selectedRegion={selectedRegion} />

			<div className='sales-network-footer' ref={footerRef}></div>

		</div>
	);
};

export default SalesNetwork;